import axios from "../../api";

export const trackTacticUsage = async (tacticId: string): Promise<void> => {
  await axios.post(`/tactics/${tacticId}/track`);
};
